import FactoryGrid from './factories/factoryGrid';
import FactoryPaper from './factories/factoryPaper';
import { VIEW_MODE } from '../../../consts';

/**
 * Возвращает фабрику для построения заголовков и строк табличного вида
 * @param viewMode режим показа
 * @param dealType тип сделки
 * @param realtyType тип недаижимости
 * @returns {*}
 */
export function getTableSearchFactory (viewMode, dealType, realtyType) {
  if (viewMode === VIEW_MODE.grid) {
    return new FactoryGrid(dealType, realtyType);
  }

  if (viewMode === VIEW_MODE.paper) {
    return new FactoryPaper(dealType, realtyType);
  }

  return new FactoryGrid(dealType, realtyType);
}



// WEBPACK FOOTER //
// ./src/classes/builder/search/tableFactoryBuilder.js